// extracted by mini-css-extract-plugin
export default {"calendar_icon":"DateInput_calendar_icon__KFI5i"};